/** Los flujos de un obligado solidario tal como los guarda el análisis de riesgos (ADR-0021). */
export interface JointObligorFlows {
  holderName?: string
  averageCashFlow?: number | null
  flows: any[]
}

/**
 * Los obligados solidarios del análisis (F-026): `jointObligors`, uno por hoja «Flujo - OS», «Flujo - OS2»…, o el
 * `jointObligor` único de los análisis importados antes. Solo los que traen cuentas: uno sin cuentas no tiene nada
 * que mostrar.
 */
export function jointObligorsOf(bankFlows: { jointObligor?: JointObligorFlows | null; jointObligors?: JointObligorFlows[] | null } | null | undefined): JointObligorFlows[] {
  const list = bankFlows?.jointObligors?.length ? bankFlows.jointObligors : bankFlows?.jointObligor ? [bankFlows.jointObligor] : []
  return list.filter((o) => Array.isArray(o?.flows) && o.flows.length > 0)
}

/** El «Flujo de Liquidez Promedio» que trae el Excel, o null si no lo trae (no se pinta un 0 inventado). */
export function liquidityAverageOf(side: Pick<JointObligorFlows, 'averageCashFlow'> | null | undefined): number | null {
  return typeof side?.averageCashFlow === 'number' ? side.averageCashFlow : null
}
